
import { css } from 'lit';
export default css`
:host([isopen]) {
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: -10;
  height: 100vh;
  overflow-y: scroll;
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

@media (min-width: 1024px) {

  :host {
    display: none;
  }
}

.nav-flyout-mobile--closed {
  display: none;
}

.nav-flyout-mobile--open {
  visibility: visible;
}

.nav-flyout-mobile__wrapper {
  width: 100vw;
}

.nav-flyout-mobile__wrapper {
  overflow: hidden;
}

.nav-flyout-mobile__wrapper {
  --tw-bg-opacity: 1;
  background-color: rgba(53, 25, 108, var(--tw-bg-opacity));
}

@media (min-width: 768px) {

.nav-flyout-mobile__wrapper {
      overflow: initial
  }
    }

.nav-flyout-mobile__header {
  display: flex;
}

.nav-flyout-mobile__header {
  flex-direction: column;
}

.nav-flyout-mobile__header {
  padding: 1rem;
}

@media (min-width: 768px) {

  .nav-flyout-mobile__header {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

@media (min-width: 768px) {

  .nav-flyout-mobile__header {
    padding-top: 1.25rem;
  }
}

.nav-flyout-mobile__logo-wrapper {
  margin-bottom: 2rem;
}

.nav-flyout-mobile__logo-wrapper {
  height: 100%;
}

.nav-flyout-mobile__logo-wrapper {
  width: 12rem;
}

.nav-flyout-mobile__logo-wrapper {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.nav-flyout-mobile__global-menu-wrapper {
  margin-bottom: 2rem;
}

.nav-flyout-mobile__global-menu-wrapper {
  flex-direction: row;
}

.nav-flyout-mobile__global-menu-wrapper {
  align-items: flex-start;
}

.nav-flyout-mobile__global-menu-item {
  display: inline-block;
}

.nav-flyout-mobile__global-menu-item {
  border-right-width: 1px;
}

.nav-flyout-mobile__global-menu-item {
  --tw-border-opacity: 1;
  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
}

.nav-flyout-mobile__global-menu-item {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.nav-flyout-mobile__global-menu-item {
  font-size: 1.25rem;
}

.nav-flyout-mobile__global-menu-item {
  line-height: 1.25rem;
}

.nav-flyout-mobile__global-menu-item:first-child {
  padding-left: 0px;
}

.nav-flyout-mobile__global-menu-item:last-child {
  border-right-width: 0px;
}

.nav-flyout-mobile__global-menu-link {
  border-bottom-width: 3px;
}

.nav-flyout-mobile__global-menu-link {
  border-color: transparent;
}

.nav-flyout-mobile__global-menu-link {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.nav-flyout-mobile__global-menu-link:hover {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}

.nav-flyout-mobile__global-menu-link.active {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}

.nav-flyout-mobile__global-menu-link.active {
  font-weight: 700;
}

.nav-flyout-mobile__search {
  width: 100%;
}

.nav-flyout-mobile__prime-links-wrapper {
  margin-top: 0.5rem;
}

.nav-flyout-mobile__prime-links-wrapper {
  width: 100%;
}

@media (min-width: 768px) {

  .nav-flyout-mobile__prime-links-wrapper {
    margin-top: 1.5rem;
  }
}

.nav-flyout-mobile__secondary-links-wrapper {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.nav-flyout-mobile__secondary-links-wrapper {
  padding-left: 2rem;
  padding-right: 2rem;
}

.nav-flyout-mobile__secondary-links-wrapper {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.nav-flyout-mobile__secondary-links-wrapper {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

.nav-flyout-mobile__secondary-links-wrapper {
    padding-top: 36px;
  }

.nav-flyout-mobile__tier2-links-wrapper {
  margin-bottom: 3rem;
}

.nav-flyout-mobile__tier2-links-wrapper {
  display: grid;
}

.nav-flyout-mobile__tier2-links-wrapper {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

@media (min-width: 768px) {

  .nav-flyout-mobile__tier2-links-wrapper {
    margin-bottom: 2.5rem;
  }
}

@media (min-width: 768px) {

  .nav-flyout-mobile__tier2-links-wrapper {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {

  .nav-flyout-mobile__tier2-links-wrapper {
      -moz-column-gap: 6rem;
           column-gap: 6rem;
  }
}

@media (min-width: 768px) {

  .nav-flyout-mobile__tier2-links-wrapper {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

.nav-flyout-mobile__tier2-links-item {
  border-top-width: 1px;
}

.nav-flyout-mobile__tier2-links-item {
  --tw-border-opacity: 1;
  border-color: rgba(109, 89, 149, var(--tw-border-opacity));
}

.nav-flyout-mobile__tier2-links-item {
  padding-left: 2rem;
  padding-right: 2rem;
}

.nav-flyout-mobile__tier2-links-item:first-child {
  border-top-width: 0px;
}

@media (min-width: 768px) {

  .nav-flyout-mobile__tier2-links-item {
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media (min-width: 768px) {

  .nav-flyout-mobile__tier2-links-item:nth-child(-n + 2) {
    border-top-width: 0px;
  }
}

.nav-flyout-mobile__tier2-links-link {
  display: block;
}

.nav-flyout-mobile__tier2-links-link {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.nav-flyout-mobile__tier2-links-link {
  font-size: 1.5rem;
}

.nav-flyout-mobile__tier2-links-link {
  font-weight: 700;
}

.nav-flyout-mobile__secondary-links-wrapper, .nav-flyout-mobile__tier3-links-wrapper, .nav-flyout-mobile__secondary-menu-wrapper, .nav-flyout-mobile__tier1-links-wrapper {
  display: grid;
}

.nav-flyout-mobile__secondary-links-wrapper, .nav-flyout-mobile__tier3-links-wrapper, .nav-flyout-mobile__secondary-menu-wrapper, .nav-flyout-mobile__tier1-links-wrapper {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.nav-flyout-mobile__secondary-links-wrapper,
  .nav-flyout-mobile__tier3-links-wrapper,
  .nav-flyout-mobile__secondary-menu-wrapper,
  .nav-flyout-mobile__tier1-links-wrapper {
    grid-auto-rows: -webkit-max-content;
    grid-auto-rows: max-content;
  }

@media (min-width: 768px) {

  .nav-flyout-mobile__secondary-links-wrapper, .nav-flyout-mobile__tier3-links-wrapper, .nav-flyout-mobile__secondary-menu-wrapper, .nav-flyout-mobile__tier1-links-wrapper {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {

  .nav-flyout-mobile__secondary-links-wrapper, .nav-flyout-mobile__tier3-links-wrapper, .nav-flyout-mobile__secondary-menu-wrapper, .nav-flyout-mobile__tier1-links-wrapper {
      -moz-column-gap: 1rem;
           column-gap: 1rem;
  }
}

.nav-flyout-mobile__tier1-links-item {
  border-top-width: 1px;
}

.nav-flyout-mobile__tier1-links-item {
  --tw-border-opacity: 1;
  border-color: rgba(109, 89, 149, var(--tw-border-opacity));
}

.nav-flyout-mobile__tier1-links-item {
  font-size: 0.875rem;
}

.nav-flyout-mobile__tier1-links-item {
  font-weight: 700;
}

.nav-flyout-mobile__tier1-links-item {
  text-transform: uppercase;
}

.nav-flyout-mobile__tier1-links-link {
  display: block;
}

.nav-flyout-mobile__tier1-links-link {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.nav-flyout-mobile__tier1-links--icon {
  margin-right: 1.5rem;
}

.nav-flyout-mobile__tier1-links--icon {
  margin-left: 2rem;
}

.nav-flyout-mobile__tier1-links--icon {
  height: 1.25rem;
}

.nav-flyout-mobile__tier1-links--icon {
  width: 1.25rem;
}

.nav-flyout-mobile__secondary-menu-wrapper {
  margin-bottom: 2rem;
}

@media (min-width: 768px) {

  .nav-flyout-mobile__secondary-menu-wrapper {
    margin-bottom: 0px;
  }
}

.nav-flyout-mobile__secondary-menu--icon {
    margin-right: 15px;
    width: 23px;
    height: 23px
  }

@media (min-width: 768px) {

  .nav-flyout-mobile__secondary-menu--icon {
    height: 1.25rem;
  }
}

@media (min-width: 768px) {

  .nav-flyout-mobile__secondary-menu--icon {
    width: 1.25rem;
  }
}

.nav-flyout-mobile__secondary-menu--icon[name="globe"] {
      margin-top: 2px;
    }

.nav-flyout-mobile__tier3-links-item, .nav-flyout-mobile__secondary-menu-item {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.nav-flyout-mobile__tier3-links-item, .nav-flyout-mobile__secondary-menu-item {
  font-size: 1.125rem;
}

.nav-flyout-mobile__tier3-links-item, .nav-flyout-mobile__secondary-menu-item {
  font-weight: 700;
}

.nav-flyout-mobile__secondary-menu-item {
  font-size: 1.5rem;
}

@media (min-width: 768px) {

  .nav-flyout-mobile__secondary-menu-item {
    font-size: 1.125rem;
  }
}

.nav-flyout-mobile__secondary-menu-item a {
  display: flex;
}

.nav-flyout-mobile__secondary-menu-item a {
  align-items: center;
}

.nav-flyout-mobile__secondary-menu-item:first-child {
  padding-top: 0px;
}

@media (min-width: 768px) {

  .nav-flyout-mobile__secondary-menu-item:first-child {
    padding-top: 0.5rem;
  }
}

.nav-flyout-mobile__secondary-menu-item:last-child {
  padding-bottom: 0px;
}

@media (min-width: 768px) {

  .nav-flyout-mobile__secondary-menu-item:last-child {
    padding-top: 0.5rem;
  }
}

@media (min-width: 768px) {

.nav-flyout-mobile__secondary-menu-item:last-child {
        grid-column: 2
    }
      }

.nav-flyout-mobile__secondary-menu-link:hover, .nav-flyout-mobile__tier1-links-link:hover, .nav-flyout-mobile__tier2-links-link:hover, .nav-flyout-mobile__tier3-links-link:hover {
  text-decoration: underline;
}

.nav-flyout-mobile__secondary-menu-link-icon {
  height: 0.5rem;
}

.nav-flyout-mobile__secondary-menu-link-icon {
  width: 0.625rem;
}

.nav-flyout-mobile__secondary-menu-link-icon {
    margin-left: 11px;
  }

.nav-flyout-mobile__secondary-menu-dropdown-list {
    margin-top: 120px;
    padding-left: 37px;
  }

.nav-flyout-mobile__secondary-menu-dropdown-list-item {
  position: relative;
}

.nav-flyout-mobile__secondary-menu-dropdown-list-item {
  margin-bottom: 1rem;
}

.nav-flyout-mobile__secondary-menu-dropdown-list-item {
  display: flex;
}

.nav-flyout-mobile__secondary-menu-dropdown-list-item {
  align-items: center;
}

.nav-flyout-mobile__secondary-menu-dropdown-list-item {
  font-weight: 400;
}

.nav-flyout-mobile__secondary-menu-dropdown-list-item {
      font-size: 22px;
    }

.nav-flyout-mobile__secondary-menu-dropdown-list-item::before {
  margin-right: 1rem;
}

.nav-flyout-mobile__secondary-menu-dropdown-list-item::before {
  display: inline-block;
}

.nav-flyout-mobile__secondary-menu-dropdown-list-item::before {
  height: 1.25rem;
}

.nav-flyout-mobile__secondary-menu-dropdown-list-item::before {
  width: 1.25rem;
}

.nav-flyout-mobile__secondary-menu-dropdown-list-item::before {
  border-width: 1px;
}

.nav-flyout-mobile__secondary-menu-dropdown-list-item::before {
  --tw-border-opacity: 1;
  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
}

.nav-flyout-mobile__secondary-menu-dropdown-list-item::before {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.nav-flyout-mobile__secondary-menu-dropdown-list-item::before {
        content: '';
        border-radius: 30px;
      }

.nav-flyout-mobile__secondary-menu-dropdown-list-item--active {
  font-weight: 700;
}

.nav-flyout-mobile__secondary-menu-dropdown-list-item--active::after {
  display: inline-block;
}

.nav-flyout-mobile__secondary-menu-dropdown-list-item--active::after {
  border-width: 0px;
}

.nav-flyout-mobile__secondary-menu-dropdown-list-item--active::after {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.nav-flyout-mobile__secondary-menu-dropdown-list-item--active::after {
          content: '';
          border-radius: 30px;
          position: absolute;
          left: 7px;
          width: 6px;
          height: 6px;
        }

.nav-flyout-mobile__secondary-menu-dropdown-list-item--active::before {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}

.nav-flyout-mobile__secondary-menu-dropdown-list-item--active::before {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

#google_translate_element .icon-navigation__dropdown {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

#google_translate_element .goog-te-gadget-simple {
    display: flex;
    align-items: center;
  }

#google_translate_element .goog-te-gadget-simple > span {
      display: flex;
    }

#google_translate_element .goog-te-gadget span a > * {
        display: none;
      }

#google_translate_element .goog-te-gadget span a > span:first-child {
        display: block;
      }

#google_translate_element .goog-te-menu-value {
  font-family: Lato, sans-serif;
}

#google_translate_element .goog-te-menu-value {
  font-size: 1.125rem;
}

#google_translate_element .goog-te-menu-value {
  font-weight: 700;
}

#google_translate_element .goog-te-menu-value {
  line-height: 1.5;
}

#google_translate_element .goog-te-menu-value {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

@media (min-width: 1024px) {

  #google_translate_element .goog-te-menu-value {
    font-size: 1.25rem;
  }
}

#google_translate_element .goog-te-menu-value {
    display: flex;
  }

#google_translate_element .goog-te-menu-value > * {
      display: none;
    }

#google_translate_element .goog-te-menu-value > span:first-child {
      display: block;
    }

#google_translate_element .goog-te-gadget-icon {
    height: 19px;
    margin-right: 0.5rem;
  }
`;